import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import type { HTMLAttributes } from 'react';
import React from 'react';
export type BreadcrumbProps = {
  'aria-label': string;
  children: React.ReactNode;
  separator?: string;
  className?: string;
} & HTMLAttributes<HTMLElement>;
const Breadcrumb = t0 => {
  const $ = _c(24);
  let children;
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      children,
      separator: t1,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = t1;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    t1 = $[4];
  }
  const separator = t1 === undefined ? "/" : t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[5] !== children || $[6] !== className || $[7] !== props || $[8] !== separator) {
    const items = React.Children.toArray(children);
    t4 = "entity-breadcrumb";
    if ($[14] !== className) {
      t5 = cx("flex flex-row gap-2", "[&>a]:no-underline [&>a:hover]:text-tertiary [&>a:hover]:underline", className);
      $[14] = className;
      $[15] = t5;
    } else {
      t5 = $[15];
    }
    t6 = props;
    t2 = "flex flex-row gap-2";
    t3 = items.map((child, index) => {
      const stableKey = React.isValidElement(child) && child.key ? child.key : index;
      return <React.Fragment key={stableKey}>{child}{index !== items.length - 1 && <li className="text-label-2 text-tertiary">{separator}</li>}</React.Fragment>;
    });
    $[5] = children;
    $[6] = className;
    $[7] = props;
    $[8] = separator;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t2 = $[9];
    t3 = $[10];
    t4 = $[11];
    t5 = $[12];
    t6 = $[13];
  }
  let t7;
  if ($[16] !== t2 || $[17] !== t3) {
    t7 = <ol className={t2}>{t3}</ol>;
    $[16] = t2;
    $[17] = t3;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t4 || $[20] !== t5 || $[21] !== t6 || $[22] !== t7) {
    t8 = <nav id={t4} className={t5} {...t6}>{t7}</nav>;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
};
export default Breadcrumb;